module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.47dbe582.ttf";